/**
 * Site-of-care detection for provider table rows.
 *
 * Provider tables mix HCP/provider rows with site-of-care rows. Only sites of
 * care carry a CCN and a distinct hex Site ID, so the CCN / Site ID columns are
 * only worth showing (and exporting) when a list actually contains a site of
 * care. Use these helpers to drive that conditional column visibility rather than
 * hand-rolling type checks per table.
 *
 * A row is treated as a site of care when either:
 * - its entity type is `site_of_care` — the API type value used across the app
 *   (e.g. `ProfileDrawer`/`TypeIcon` type checks, `profileUrl` SLUG_MAP). Rows
 *   expose it as `content_type` or `type`, so both are checked; or
 * - it carries a `soc_type` value — what the Site of Care Type column reads via
 *   `formatSocClassification` (`socTypes.ts`).
 */
const SITE_OF_CARE_TYPE = 'site_of_care';

export const isSiteOfCareRow = (row?: Record<string, any> | null): boolean => {
  const entityType = String(row?.content_type ?? row?.type ?? '').toLowerCase();
  return entityType === SITE_OF_CARE_TYPE || Boolean(row?.soc_type);
};

export const hasSitesOfCare = (
  rows?: Array<Record<string, any>> | null
): boolean => Array.isArray(rows) && rows.some(isSiteOfCareRow);
